import { Button, ButtonProps, useBreakpoint } from "@avenue-8/sidekick-ui";
import styled from "@emotion/styled";
import AddIcon from "@mui/icons-material/Add";

const FixedButton = styled(Button)`
  position: absolute;
  right: 1rem;
`;

export const AddComparablePropertyButton = (props: ButtonProps) => {
  const isMobileDown = useBreakpoint("mobile");
  return (
    <FixedButton
      startIcon={<AddIcon />}
      size="small"
      variant="outlined"
      {...props}
    >
      {isMobileDown ? "Add" : "Add Property"}
    </FixedButton>
  );
};
